// TODO: (low priority) Isolate Match-Prep events as done with other context-isolated evets in "common\network\src\consts\match-making.events.ts"

export enum SocketEvents {
  connect = 'connect',
  connection = 'connection',
  disconnect = 'disconnect',
  reconnect = 'reconnect',
  connectErrorClient = 'connect_error',
  connectErrorServer = 'connection_error',
  connectTest = 'connectTest',
  connectTestResp = 'connectTestResp',
  error = 'error',
  pingTest = 'pingTest',

  // Pregame
  fetchEnvVarsReq = 'fetchEnvVarsReq',
  fetchEnvVarsResp = 'fetchEnvVarsResp',
  fetchCombatGameConfigsReq = 'fetchCombatGameConfigsReq',
  fetchCombatGameConfigsResp = 'fetchCombatGameConfigsResp',
  loadAssetsReq = 'loadAssetsReq',
  loadAssetsResp = 'loadAssetsResp',
  earlyEnginePlayerSync = 'earlyEnginePlayerSync',

  // Lobby
  initialLobbyReq = 'initialLobbyReq',
  initialLobbyResp = 'initialLobbyResp',
  newLobbyReq = 'newLobbyReq',
  changeLobbyResp = 'changeLobbyResp',
  highlightMapReq = 'highlightMapReq',
  highlightMapResp = 'highlightMapResp',
  updateUserLoadoutReq = 'updateUserLoadoutReq',
  updateUserLoadoutResp = 'updateUserLoadoutResp',
  setReadyStatusReq = 'setReadyStatusReq',
  setReadyStatusResp = 'setReadyStatusResp',
  cancelAllReadyStatusResp = 'cancelAllReadyStatusResp',
  lobbyDisconnectingError = 'lobbyDisconnectingError',
  matchMakingStart = 'matchMakingStart',
  matchMakingUpdate = 'matchMakingUpdate',
  matchMakingCancel = 'matchMakingCancel',
  matchMakingComplete = 'matchMakingComplete',
  userMpMatchReady = 'userMpMatchReady',
  enterMatchResp = 'enterMatchResp',
  createNewMatchReq = 'createNewMatchReq',
  reconnectToMatchReq = 'reconnectToMatchReq',
  reconnectToLobbyReq = 'reconnectToLobbyReq',
  reconnectToLobbyResp = 'reconnectToLobbyResp',

  // Lobby-debug
  novaUserListReq = 'novaUserListReq',
  novaUserListResp = 'novaUserListResp',
  novaUserCreateReq = 'novaUserCreateReq',
  allLobbiesReq = 'allLobbiesReq',
  allLobbiesResp = 'allLobbiesResp',
  roleSkillKeysReq = 'roleSkillKeysReq',
  roleSkillKeysResp = 'roleSkillKeysResp',

  // Player
  selectBoost = 'selectBoost',
  selectBoostResp = 'selectBoostResp',
  purchaseBoost = 'purchaseBoost',
  purchaseBoostResp = 'purchaseBoostResp',
  setBoost = 'setBoost',
  sendPointerInput = 'sendPointerInput',
  sendActiveKeyInput = 'sendActiveKeyInput',
  sendMoveCoords = 'sendMoveCoords',
  sendCoreSkillTarget = 'sendCoreSkillTarget',
  partSkillInput = 'partSkillInput',
  selfCastPartSkill = 'selfCastPartSkill',
  toggleAutoCast = 'autoCast',
  reconnectToPlayerReq = 'reconnectToPlayerReq',
  voluntaryDisconnect = 'voluntaryDisconnect',
  entityUnderMatchControl = 'entityUnderMatchControl',

  // Tutorial
  tutorialClickNext = 'tutorialClickNext',

  // Player-debug
  sendDebugInput = 'sendDebugInput',

  // Match
  leaveMatchBeforeEnd = 'leaveMatchBeforeEnd',
  startPreloadSyncTimer = 'startPreloadSyncTimer',
  startMatchReadySyncTimer = 'startMatchReadySyncTimer',
  clientPreloadSync = 'clientPreloadSync',
  clientMatchReadySync = 'clientMatchReadySync',
  matchLaunch = 'matchLaunch',
  engineUpdate = 'engineUpdate',
  matchEndOr = 'matchEndOr',
  matchEndZr = 'matchEndZr',
  matchEndBase = 'matchEndBase',
  matchPlayerDisconnect = 'matchPlayerDisconnect',
  matchKick = 'matchKick',
  afkTrigger = 'afkTrigger',
  spMatchStart = 'spMatchStart',
  spMatchEnd = 'spMatchEnd',
  // Match-debug
  clearRoom = 'clearRoom',
  forceMatchEnd = 'forceMatchEnd',
  setPlayerDebugSettings = 'setPlayerDebugSettings'
}
